import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";
import type { AdminPendingActionsVM } from "@shared-kernel/application/ports/admin/admin-repository";

const EMPTY_PENDING_ACTIONS: AdminPendingActionsVM = {
  hasActions: false,
  fundingRequestsToReview: { pendingCount: 0 },
  fundingRequestsToSubmitToFunder: { pendingCount: 0 },
  teacherPayoutsToPay: { pendingCount: 0 },
  standardTeacherPayoutsToPay: { pendingCount: 0 },
  studentRefundsToProcess: { pendingCount: 0 },
  providerBatchInvoicesToProcess: { pendingCount: 0 },
  teacherBatchInvoicesToProcess: { pendingCount: 0 },
  collaborationRequestsToReview: { pendingCount: 0 },
  batchEnrollmentCandidatesToReview: { pendingCount: 0 },
  trainingInvoicesToProcess: { pendingCount: 0 },
  externalProviderRequestsToReview: { pendingCount: 0 },
  externalProviderPaymentsToApprove: { pendingCount: 0 },
};

export const selectAdminPendingActions = createSelector(
  [(state: AppState) => state.admin.pendingActionsRetrieval],
  ({ data, fetching }) => {
    if (fetching === "success" && data) {
      return data;
    }
    return EMPTY_PENDING_ACTIONS;
  },
);

export const selectAdminHasActions = createSelector([selectAdminPendingActions], data => data.hasActions);
